// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1i9W8","col":"styles_col__2JGPR","actions":"styles_actions__3vCnS","conflict":"styles_conflict__3KkDC"};